import { forwardRef } from 'react'

export const Giphy = forwardRef<SVGSVGElement>(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14243 2.57166H11.8583V15.4283H2.1416L2.14243 2.57166Z"
        fill="black"
      />
      <path d="M0.199951 2.09497H2.14245V15.905H0.199951V2.09497Z" fill="#04FF8E" />
      <path d="M11.8574 5.90491H13.7999V15.9049H11.8574V5.90491Z" fill="#8E2EFF" />
      <path d="M0.199951 15.4283H13.8V17.3333H0.199951V15.4283Z" fill="#00C5FF" />
      <path d="M0.199951 0.666626H7.97162V2.57163H0.199951V0.666626Z" fill="#FFF152" />
      <path d="M11.8575 4.47579V2.57163H9.91418V0.666626H7.97168V6.38079H13.8V4.47579" fill="#FF5B5B" />
      <path d="M11.8574 8.28574V6.38074H13.7999" fill="#551C99" />
      <path fillRule="evenodd" clipRule="evenodd" d="M7.97165 0.666626V2.57163H6.02832" fill="#999131" />
    </svg>
  )
})

export default Giphy
